import { WxdhPopupSyle } from "./style"

const WxdhPopup = ({ close }: { close: () => void }) => {

    return <WxdhPopupSyle>
        <div className="popup-title">
            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-title-left.png" alt="" />
            “万仙大会”修仙世界游戏设计创意大赛
            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-title-right.png" alt="" />
        </div>
        <img className="top" src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-word.png" />
        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-baner-part-tow-icon.png" className="flower" />
        <div className="content-wrap">
            <div className="content">
                <div>
                    
                    <div className="date">活动时间：即日起 至 <span>2025</span>年<span>6</span>月<span>30</span>日</div>
                    <div className="sub-title">
                        <div className="sub-word">仙界告示</div>
                    </div>
                    <div className="tip">万元修仙基金（共<span>20</span>位）。</div>
                    <div className="word">
                        <div>欢迎踏上本次修仙之旅！助力你的修仙梦,去构建属于你的那一方仙境,提笔书写属于你的修仙传奇吧!</div>
                        <div>本次发放超万元修仙基金，助推大家的修仙之路。无论是想成为宗门弟子、亦或是散修闲人，</div>
                        <div>点击下方立即申请，提交完成作品即可获得修仙基金。</div>
                        <div>席位有限，御剑速来！</div>
                    </div>
                    <div className="btn" onClick={() => window.open("https://wj.qq.com/s2/22138908/0ce0/")}>
                        <div>立即申请</div>
                    </div>
                    <div className="tip2">获得创意基金的参赛作品，仍可参与本赛事的奖项评选。</div>
                    <div className="sub-title">
                        <div className="sub-word">活动时间</div>
                    </div>
                    <div className="date">
                        <div>即日起 至 <span>2025</span>年<span>6</span>月<span>30</span>日</div>
                    </div>
                    <div className="sub-title">
                        <div className="sub-word">参与方式</div>
                    </div>
                    <div className="word">
                        <div><span>1</span>、点击立即申请，提交个人简介、创意概念、预期成果。</div>
                        <div><span>2</span>、等待官方进行审核，审核通过后即可锁定「创意席位」。</div>
                        <div><span>3</span>、发挥你的创意开始创作，赛事截稿前提交完成作品，即可获得<span>500</span>元创意基金。</div>
                    </div>
                    <div className="sub-title">
                        <div className="sub-word">活动须知</div>
                    </div>
                    <div className="word">
                        <div><span>1</span>、参与本活动需进行申请，申请通过后可锁定「修仙席位」，视为正式参与。</div>
                        <div><span>2</span>、锁定「修仙席位」后，需根据赛事规则完成作品创作并提交后，方可正式获得创意基金;</div>
                        <div>未按照赛事规则完成并提交的作品，则视为无效参与。 </div>
                        <div><span>3</span>、赛事组委会将在赛事截稿后与创作者取得联系并发放创意基金。</div>
                        <div><span>4</span>、赛事组委会对本次活动拥有最终解释权。</div>
                    </div>
                    <div className="tip3">如对活动有疑问可联系小<span>G</span>（微信：GGAC<span>2025</span>）</div>
                </div>
            </div>
            <div className="close-wrap">
                <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-popup-close.png" onClick={close} className="close" />
            </div>
        </div>
    </WxdhPopupSyle>
}

export default WxdhPopup